import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Introduction from "./Introduction";
import SubSection1 from "./Subsection1";
import SubSection2 from "./Subsection2";
import SubSection3 from "./Subsection3";
import SubSection4 from "./Subsection4";
import Subsection4b from "./Subsection4b";
import SubSection5 from "./Subsection5";
import Subsection5b from "./Subsection5b";
import SubSection6 from "./Subsection6";
import Subsection6b from "./Subsection6b";
import SubSection7 from "./Subsection7";
import Subsection8 from "./Subsection8";
import Subsection9 from "./Subsection9";
import BreadcrumbNav from "../../navigation/Breadcrumb";
import BottomNavigation from "../../navigation/BottomNavigation";

interface NegotiationTermsProps {
  toggleSection: (section: string, open?: boolean) => void;
}

const NegotiationTerms: FC<NegotiationTermsProps> = ({ toggleSection }) => {
  const { subsection } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [subsection]);

  useEffect(() => {
    toggleSection("The Negotiation Terms", true);
  }, [toggleSection])


  useEffect(() => {
    if (subsection === "permissible-uses-of-startup-fund" || subsection === "responses-to-other-prompts-permissible-uses-startup-fund") {
      toggleSection("The Negotiation Terms/Permissible uses of startup funds in outside offer", true);
    }

    if (subsection === "counteroffers-sought-and-counteroffers-received" || subsection === "responses-to-other-prompts-counteroffers-sought-and-counteroffers-received") {
      toggleSection("The Negotiation Terms/Counteroffers sought and counteroffers received", true);
    }

    if (subsection === "your-counteroffer-proposed-changes" || subsection === "responses-to-other-prompts-your-counteroffer-proposed-changes") {
      toggleSection("The Negotiation Terms/Your counteroffer: Proposed changes", true);
    }
  }, [toggleSection, subsection])

  return (
    <>
      <BreadcrumbNav section="negotiation-terms" subsection={subsection} />

      <h1>The Negotiation Terms</h1>
      {subsection === "introduction" && <Introduction />}
      {subsection === "origin-of-outside-offers" && <SubSection1 />}
      {subsection === "rank-tenure-title" && <SubSection2 />}
      {subsection === "compensation" && <SubSection3 />}
      {subsection === "permissible-uses-of-startup-fund" && <SubSection4 />}
      {subsection === "responses-to-other-prompts-permissible-uses-startup-fund" && <Subsection4b />}
      {subsection === "counteroffers-sought-and-counteroffers-received" && <SubSection5 />}
      {subsection === "responses-to-other-prompts-counteroffers-sought-and-counteroffers-received" && <Subsection5b />}
      {subsection === "your-counteroffer-proposed-changes" && <SubSection6 />}
      {subsection === "responses-to-other-prompts-your-counteroffer-proposed-changes" && <Subsection6b />}
      {subsection === "your-counteroffer-extent-matched" && <SubSection7 />}
      {subsection === "your-counteroffer-faculty-assessment-of-comparison" && <Subsection8 />}
      {subsection === "your-counteroffer-why-it-did-not-materialize" && <Subsection9 />}

      <BottomNavigation />
    </>
  )
}

export default NegotiationTerms;